module.exports = __webpack_public_path__ + "img/20190625161827QQ截图20190624162751.0b09a719.png";